// extracted by mini-css-extract-plugin
module.exports = {"text-container":"_1JkIa","headline":"HgN6D","subheadline":"_3jpn-","hero-image":"_10zIw","card-container":"_23got"};